import { render, staticRenderFns } from "./SceltaLenti.vue?vue&type=template&id=6af13f3b"
import script from "./SceltaLenti.vue?vue&type=script&lang=js"
export * from "./SceltaLenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports